import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
/* eslint-disable no-unused-vars */
import { useQuery } from '@apollo/client';
import { UPGRADE_STATUS } from '@app/apollo/queries';
import { Router, useTranslation } from '@app/config/i18n';
import { isOrganiser, redirectToRoute, setAuthCookie } from '@app/helpers';
import { useUser } from '@app/helpers/hooks';
import Link from '@atoms/Link';
import { Button, IconButton, MenuItem, Toolbar, Menu } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LocaleSelect from '@molecules/LocaleSelect';
import Image from 'next/image';
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { AppBar, LogoContainer, StyledMenu, UserAvatar, UserButton } from './style';

// import CookieAlert from '@molecules/common/CookieAlert';
// import Button from '@atoms/Button';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = function Header(_ref) {
  var _user$avatar;
  var sidebar = _ref.sidebar,
    onClick = _ref.onClick,
    hasElevation = _ref.hasElevation;
  var _useState = useState(false),
    auth = _useState[0],
    setAuth = _useState[1];
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    logo = _React$useState2[0],
    setLogo = _React$useState2[1];
  // const [showCookieAlert, setShowCookieAlert] = useState(false);
  var _useState2 = useState(false),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = useState(null),
    anchorEl = _useState3[0],
    setAnchorEl = _useState3[1];
  var _useTranslation = useTranslation(['common', 'applications']),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _ref2 = useUser() || {},
    user = _ref2.user;
  var _useQuery = useQuery(UPGRADE_STATUS),
    _useQuery$data = _useQuery.data;
  _useQuery$data = _useQuery$data === void 0 ? {} : _useQuery$data;
  var upgradeStatus = _useQuery$data.upgradeStatus,
    loading = _useQuery.loading;
  var open = Boolean(anchorEl);
  React.useEffect(function () {
    if (typeof window !== 'undefined' && window.innerWidth < 600) {
      setIsMobile(true);
      //  setLogo();
    }
  }, []);

  //  console.log(upgradeStatus)

  if (!auth && user) {
    setAuth(true);
  }
  var handleMenu = function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var redirectToProfile = function redirectToProfile() {
    redirectToRoute({}, 'update_profile');
  };
  var redirectToUpgradeAcount = function redirectToUpgradeAcount() {
    // let route = 'my_opportunities';
    // if (auth && user.role.name === USER_ROLES.USER) {
    //   route = 'my_applications';
    // }
    redirectToRoute({}, 'account_upgrade');
  };
  var signOutHandler = function signOutHandler() {
    setAuthCookie(null);
    Cookies.remove('token');
    Router.reload();
  };
  var getHomeHref = function getHomeHref() {
    var route = '/';
    if (auth && user) {
      if (user.selected_type && user.selected_type === "organiser") {
        route = 'my_opportunities';
      } else {
        route = 'opportunity_search';
        ;
      }
    }
    return route;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(AppBar, {
      position: "fixed",
      haselevation: hasElevation ? 1 : 0,
      children: /*#__PURE__*/_jsxs(Toolbar, {
        children: [sidebar && /*#__PURE__*/_jsx(IconButton, {
          color: "inherit",
          "aria-label": "open drawer",
          onClick: onClick,
          edge: "start",
          children: /*#__PURE__*/_jsx(MenuIcon, {})
        }), /*#__PURE__*/_jsx(LogoContainer, {
          children: /*#__PURE__*/_jsx(Link, {
            href: getHomeHref(),
            color: "inherit",
            title: "home page",
            style: {
              display: 'flex'
            },
            children: isMobile ? /*#__PURE__*/_jsx(Image, {
              bottom: "0.3125rem",
              width: "50px",
              height: "50px",
              src: "/images/logo-mobile.png",
              alt: "Mubazar"
            }) : /*#__PURE__*/_jsx(Image, {
              bottom: "0.3125rem",
              width: "143px",
              height: "30px",
              src: "/images/mubazar-logo-final-white.png",
              alt: "Mubazar"
            })
          })
        }), /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(LocaleSelect, {
            id: "header-language-menu"
          }), auth && user ? /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(UserButton
            // variant="outlined"
            , {
              variant: "text",
              color: "inherit",
              onClick: handleMenu,
              children: [' ', /*#__PURE__*/_jsx(UserAvatar, {
                color: "primary",
                width: "40px",
                src: user === null || user === void 0 ? void 0 : (_user$avatar = user.avatar) === null || _user$avatar === void 0 ? void 0 : _user$avatar.thumb
              }), !isMobile && (user === null || user === void 0 ? void 0 : user.name), ' ']
            }), /*#__PURE__*/_jsxs(StyledMenu, {
              id: "menu-appbar",
              anchorEl: anchorEl,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
              },
              keepMounted: true,
              transformOrigin: {
                vertical: 'bottom',
                horizontal: 'right'
              },
              open: open,
              onClose: handleClose,
              children: [/*#__PURE__*/_jsx(MenuItem, {
                onClick: redirectToProfile,
                children: t('common:profile')
              }), /*#__PURE__*/_jsx(MenuItem, {
                onClick: signOutHandler,
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/",
                  style: {
                    textDecoration: 'none'
                  },
                  color: "inherit",
                  children: t('logout')
                })
              }), user && !isOrganiser(user) && /*#__PURE__*/_jsx(MenuItem, {
                style: {
                  borderTop: '1px solid lightgray'
                },
                disabled: upgradeStatus && upgradeStatus.status === 'waiting' || upgradeStatus === 'organizer',
                onClick: redirectToUpgradeAcount,
                children: t('common:upgrade_account')
              })]
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Link, {
              href: "login",
              id: "login",
              color: "inherit",
              children: /*#__PURE__*/_jsx(Button, {
                color: "inherit",
                children: t('login')
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: "register",
              id: "register",
              color: "inherit",
              children: /*#__PURE__*/_jsx(Button, {
                color: "inherit",
                children: t('register')
              })
            })]
          })]
        })]
      })
    })
  });
};
Header.defaultProps = {
  sidebar: false,
  hasElevation: true,
  onClick: function onClick() {}
};
export default Header;